/* unplugin-vue-components disabled */import script from "./LayoutScreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayoutScreen.vue?vue&type=script&lang=ts&setup=true"

import "./LayoutScreen.vue?vue&type=style&index=0&id=b727de38&lang=scss"

const __exports__ = script;

export default __exports__